/**
 * Document-level undo for programmatic content replacements (setContent, library pull, etc.)
 * that clear TipTap's built-in history stack.
 */

export type DocumentSnapshot<TMeta = unknown> = {
  payload: string;
  meta?: TMeta;
};

export function createDocumentUndoStack<TMeta = unknown>(maxDepth = 30) {
  const past: DocumentSnapshot<TMeta>[] = [];
  const future: DocumentSnapshot<TMeta>[] = [];

  return {
    push(payload: string, meta?: TMeta) {
      past.push({ payload, meta });
      if (past.length > maxDepth) past.shift();
      future.length = 0;
    },
    canUndo() {
      return past.length > 0;
    },
    canRedo() {
      return future.length > 0;
    },
    undo(currentPayload: string, currentMeta?: TMeta): DocumentSnapshot<TMeta> | null {
      if (!past.length) return null;
      future.push({ payload: currentPayload, meta: currentMeta });
      return past.pop() ?? null;
    },
    redo(currentPayload: string, currentMeta?: TMeta): DocumentSnapshot<TMeta> | null {
      if (!future.length) return null;
      past.push({ payload: currentPayload, meta: currentMeta });
      return future.pop() ?? null;
    },
    clear() {
      past.length = 0;
      future.length = 0;
    },
  };
}
